export const OPERATIONAL_MODES = Object.freeze({
  CLOUD: 'CLOUD_MODE',
  LOCAL_REHEARSAL: 'LOCAL_REHEARSAL_MODE',
  LOCAL: 'LOCAL_MODE',
});

export async function dispatchOperationalCommand({
  mode = OPERATIONAL_MODES.CLOUD,
  cloud,
  localRehearsal,
  local,
}) {
  if (mode === OPERATIONAL_MODES.LOCAL_REHEARSAL) {
    if (typeof localRehearsal !== 'function') {
      throw new Error('LOCAL_REHEARSAL_HANDLER_REQUIRED');
    }
    return localRehearsal();
  }
  if (mode === OPERATIONAL_MODES.LOCAL) {
    if (typeof local !== 'function') {
      throw new Error('LOCAL_MODE_HANDLER_REQUIRED');
    }
    return local();
  }
  if (mode !== OPERATIONAL_MODES.CLOUD) {
    throw new Error(`OPERATIONAL_MODE_NOT_SUPPORTED:${mode}`);
  }
  if (typeof cloud !== 'function') {
    throw new Error('CLOUD_HANDLER_REQUIRED');
  }
  return cloud();
}

export function rehearsalOnly(localRehearsal) {
  return dispatchOperationalCommand({
    mode: OPERATIONAL_MODES.LOCAL_REHEARSAL,
    localRehearsal,
  });
}
